import { EventReportFilter } from '@contexts/event-report/event-report-context.type';
import { LinearGraphGroupBy } from '@domain/event-report';
import { useGenericQuery } from '@hooks/use-generic-query';
import { paramsSerializer } from '@utils/format-params';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants';
interface EventViewsStatChannel {
  [channel: string]: number;
}
interface EventViewsStatDate {
  total: number;
  channels: EventViewsStatChannel;
}

export interface EventViewsStat {
  [date: string]: EventViewsStatDate;
}

export type EventViewsStatsResponse = EventViewsStat;

export interface EventSalesViewsStatsGroupByQueryParams extends EventReportFilter {
  groupByDate: LinearGraphGroupBy;
}

export type EventViewsStatsParams = {
  eventId?: string;
  params: EventSalesViewsStatsGroupByQueryParams;
  options?: Record<string, boolean | number>;
};

export const createEventViewsStatsQuery = (
  eventId: string | undefined,
  params: EventSalesViewsStatsGroupByQueryParams
) => [QUERY_KEYS.eventViewsStats, eventId, ...Object.values(params)];

const getCompanyEventViewsGroupby = async ({ eventId, params }: EventViewsStatsParams) => {
  const queryParams = paramsSerializer({ ...params });
  const url = `${import.meta.env.VITE_MONOLITH_HOST}/v1/nightgraph/events/${eventId}/views-stats?${queryParams}`;
  return request({ url, method: RequestMethod.GET });
};

export const useGetEventViewsStatsGroupBy = ({ eventId, params, options }: EventViewsStatsParams) => {
  return useGenericQuery<EventViewsStatsResponse, RequestError>(
    createEventViewsStatsQuery(eventId, params),
    () => getCompanyEventViewsGroupby({ eventId, params }),
    {
      ...options,
    },
    true
  );
};
